import { ReactComponent as Group } from "@assets/icons/group_icon.svg";

const GroupIcon = (props: any): JSX.Element => {
  return (
    <Group
      fill={props?.sx?.color || props?.sx?.fill}
      height={props?.sx?.height || "16px"}
      width={props?.sx?.width || props?.sx?.height || "16px"}
      {...props}
    />
  );
};

export default GroupIcon;
